const LASSO_API_KEY =
  'eyJhbGciOiJSUzI1NiJ9.eyJleHAiOjcyMjY1ODI0MDAsInRva2VuRGF0YSI6IntcbiAgXCJwcm9qZWN0SWRcIiA6IDExNjM3LFxuICBcImNsaWVudElkXCIgOiAxOSxcbiAgXCJuYW1lXCIgOiBcImxhc3NvTGVhZENhcHR1cmVcIlxufSIsImlzcyI6Ikxhc3NvVG9rZW4iLCJhdWQiOiJMYXNzbyIsInRva2VuSWQiOjI5NTk0fQ.foYXcW9erHjt7oq6DseVuDRku1NSnS5Jdnfd1kCImbPIC95LyTMqKZhcZdZ0BZgu4fO6v22F35Nk17rStot1pPbD06nxXwJDEJKq_zHXy8IT91viDioae9BY-0SP1Ou9iORftepi704ttxlGv0Dk0zcIN333WBOC2Slh97xZ_HARO1Ix9HSWCzRTn6SPVTZUwaJLpnmts_zos9B5NhlR08MtaPYPLC98OtR5liUBKI0nD7MJclvSHf0WFl75H5nbNSAAub2IN18DoSzPSpGI38R8_XP1oFISGcpFrhjr5z-sKdViStkIIIip5Bdt1n1vkCuCUalC7XcrD1xhEjkVVA';
const LASSO_API_KEY_OFFICES =
  'eyJhbGciOiJSUzI1NiJ9.eyJleHAiOjcyMjY1ODI0MDAsInRva2VuRGF0YSI6IntcbiAgXCJwcm9qZWN0SWRcIiA6IDE2MzU1LFxuICBcImNsaWVudElkXCIgOiAxOSxcbiAgXCJuYW1lXCIgOiBcImxhc3NvTGVhZENhcHR1cmVcIlxufSIsImlzcyI6Ikxhc3NvVG9rZW4iLCJhdWQiOiJMYXNzbyIsInRva2VuSWQiOjMwMTk0fQ.Xd9ycIKZCtUl8abaKpXqAnNxoj-uH7BDHAaWlLCjhvnY5Obmf4A86XBhlTY4o_BORK9tWYA6AqJByqRdjCWYAEM894X-jRNznfIzVxOcONPPplSgfuPlvm9XFf5BmqsMEDDnhyn2FvPhkHMDJ2q4AcrRAAm-eROLcYWKK7pNdFN5SSbimhLIWtSpAVWMctNPP2Ak4Q7MJs8DXucbPv75HDHkXrrGEyrAIUhS_2Lb2yzhZ_8zyn2OzJ3PNO_zBKO0YPjkJ4UojvOOkr6Nzw3zHv4TF7yTqeaa0IZiSmHn3tp3KV_G2rPevmCJcoa31XB25RVWMNsco0dPp8mw9UPpIA';
const PROXY = 'https://bam-cors-anywhere.herokuapp.com/';
const BASE_URL = 'https://api.lassocrm.com/v1';
const SEARCH_EMAIL = '/registrants/search?email=';
const REGISTRANTS = '/registrants';

const headers = (projectId) => {
  if (projectId && projectId.toLowerCase() === 'offices') {
    return {
      'Content-Type': 'application/json',
      accept: 'application/json',
      Authorization: `Bearer ${LASSO_API_KEY_OFFICES}`,
    };
  } else {
    return {
      'Content-Type': 'application/json',
      accept: 'application/json',
      Authorization: `Bearer ${LASSO_API_KEY}`,
    };
  }
};

export async function getSearchEmail(email, projectId) {
  const HEADERS = headers(projectId);
  const response = await fetch(PROXY + BASE_URL + SEARCH_EMAIL + email, {
    headers: HEADERS,
  });
  const responseJson = await response.json();

  return responseJson;
}

export async function getExtendRegistrant(registrantId, projectId) {
  const HEADERS = headers(projectId);
  const response = await fetch(
    PROXY + BASE_URL + REGISTRANTS + `/${registrantId}`,
    {
      headers: HEADERS,
    }
  );
  const responseJson = await response.json();

  return responseJson;
}

export async function setHistory(registrantId, type, projectId) {
  const HEADERS = headers(projectId);
  const dataBody = {
    type: type,
    subject: 'Register at Sales Centre',
  };
  const response = await fetch(
    PROXY + BASE_URL + REGISTRANTS + `/${registrantId}/histories`,
    {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify(dataBody),
    }
  );
  const responseJson = await response.json();

  return responseJson;
}

export async function updateHistory(registrantId, historyId, type, projectId) {
  const HEADERS = headers(projectId);
  const dataBody = {
    type: type,
    subject: 'Register at Sales Centre',
  };
  const response = await fetch(
    PROXY + BASE_URL + REGISTRANTS + `/${registrantId}/histories/${historyId}`,
    {
      method: 'PUT',
      headers: HEADERS,
      body: JSON.stringify(dataBody),
    }
  );
  const responseJson = await response.json();

  return responseJson;
}

export async function getRegistrant(registrantId, projectId) {
  const HEADERS = headers(projectId);
  const response = await fetch(
    PROXY + BASE_URL + REGISTRANTS + `/${registrantId}`,
    {
      headers: HEADERS,
    }
  );
  const responseJson = await response.json();

  return responseJson;
}

export async function getLatestRegistrant(projectId) {
  const HEADERS = headers(projectId);
  const response = await fetch(PROXY + BASE_URL + REGISTRANTS, {
    headers: HEADERS,
  });
  const responseJson = await response.json();

  return responseJson;
}

export default async function createARegistrant(projectId) {
  const HEADERS = headers(projectId);
  const firstName = document.getElementById('firstName').value;
  const lastName = document.getElementById('lastName').value;
  const email = document.getElementById('email').value;
  const phone = document.getElementById('phone').value;
  const postal = document.getElementById('postal').value;

  const realtor = document.getElementById('realtor');
  const realtorValue = realtor.options[realtor.selectedIndex].value;

  const howHeard = document.getElementById('howHeard');
  const howHeardValue = howHeard.options[howHeard.selectedIndex].value;

  const typeOfHomeValues = Array.from(
    document.querySelectorAll('input[name="typeofhome"]')
  )
    .filter((checkbox) => checkbox.checked)
    .map((checkbox) => {
      return { answer: checkbox.value, answerId: checkbox.id };
    });

  const dataBody = {
    person: {
      firstName: firstName,
      lastName: lastName,
    },
    emails: [
      {
        email: email,
        primary: true,
      },
    ],
    phones: [
      {
        phone: phone,
        primary: true,
      },
    ],
    addresses: [
      {
        zipCode: postal,
        primary: true,
      },
    ],
    questions: [
      {
        questionId: '80244',
        name: 'Home Type',
        answers: typeOfHomeValues,
      },
      {
        questionId: '80243',
        name: 'How Heard',
        answers: [
          {
            answer: howHeardValue,
          },
        ],
      },
      {
        questionId: '80246',
        name: 'Realtor',
        answers: [
          {
            answer: realtorValue,
          },
        ],
      },
      {
        questionId: '80248',
        name: 'Consent',
        answers: [
          {
            answer: 'Yes',
          },
        ],
      },
    ],
    history: [
      {
        type: 'Visit',
        subject: 'Register at Sales Centre',
      },
    ],
    sourceType: {
      sourceType: 'Online Registration',
    },
  };

  const response = await fetch(PROXY + BASE_URL + REGISTRANTS, {
    method: 'POST',
    headers: HEADERS,
    body: JSON.stringify(dataBody),
  });

  const responseJson = await response.json();

  return responseJson;
}

export async function createARegistrantOffices() {
  const HEADERS = headers('offices');
  const firstName = document.getElementById('firstName').value;
  const lastName = document.getElementById('lastName').value;
  const email = document.getElementById('email').value;
  const phone = document.getElementById('phone').value;
  const postal = document.getElementById('postal').value;
  const brokerage = document.getElementById('brokerage').value;
  const realtorName = document.getElementById('realtorName').value;
  const typeOfBusiness = document.getElementById('typeOfBusiness').value;

  const realtor = document.getElementById('realtor');
  const realtorValue = realtor.options[realtor.selectedIndex].value;

  const workWithRealtor = document.getElementById('workingWithRealtor');
  const workWithRealtorValue =
    workWithRealtor.options[workWithRealtor.selectedIndex].value;

  const preferredSize = document.getElementById('preferredSize');
  const preferredSizeValue =
    preferredSize.options[preferredSize.selectedIndex].value;

  const howHeard = document.getElementById('howHeard');
  const howHeardValue = howHeard.options[howHeard.selectedIndex].value;

  const ownerUsage = document.getElementById('ownerUsage');
  const ownerUsageValue = ownerUsage.options[ownerUsage.selectedIndex].value;

  const dataBody = {
    person: {
      firstName: firstName,
      lastName: lastName,
    },
    emails: [
      {
        email: email,
        primary: true,
      },
    ],
    phones: [
      {
        phone: phone,
        primary: true,
      },
    ],
    addresses: [
      {
        zipCode: postal,
        primary: true,
      },
    ],
    questions: [
      {
        questionId: '109713',
        name: 'Preferred Size',
        answers: [
          {
            answer: preferredSizeValue,
          },
        ],
      },
      {
        questionId: '109712',
        name: 'How Heard',
        answers: [
          {
            answer: howHeardValue,
          },
        ],
      },
      {
        questionId: '109714',
        name: 'Owner Usage or Investment',
        answers: [
          {
            answer: ownerUsageValue,
          },
        ],
      },
      {
        questionId: '109716',
        name: 'Realtor',
        answers: [
          {
            answer: realtorValue,
          },
        ],
      },
      {
        questionId: '109718',
        name: 'Working with Realtor',
        answers: [
          {
            answer: workWithRealtorValue,
          },
        ],
      },
      {
        questionId: '109715',
        name: 'Type of Business',
        answers: [
          {
            answer: typeOfBusiness,
          },
        ],
      },
      {
        questionId: '109717',
        name: 'Brokerage',
        answers: [
          {
            answer: brokerage,
          },
        ],
      },
      {
        questionId: '109719',
        name: `Realtor's Name`,
        answers: [
          {
            answer: realtorName,
          },
        ],
      },
      {
        questionId: '109720',
        name: 'Consent',
        answers: [
          {
            answer: 'Yes',
          },
        ],
      },
    ],
    history: [
      {
        type: 'Visit',
        subject: 'Register at Sales Centre',
      },
    ],
    sourceType: {
      sourceType: 'Online Registration',
    },
  };

  const response = await fetch(PROXY + BASE_URL + REGISTRANTS, {
    method: 'POST',
    headers: HEADERS,
    body: JSON.stringify(dataBody),
  });

  const responseJson = await response.json();

  return responseJson;
}

export async function updateRegistrantContactInformation(
  registrantId,
  projectId
) {
  const HEADERS = headers(projectId);
  const firstName = document.getElementById('firstName').value;
  const lastName = document.getElementById('lastName').value;
  const email = document.getElementById('email').value;
  const phone = document.getElementById('phone').value;
  const postal = document.getElementById('postal').value;

  const dataBody = {
    firstName: firstName,
    lastName: lastName,
    emails: [
      {
        email: email,
        primary: true,
      },
    ],
    phones: [
      {
        phone: phone,
        primary: true,
      },
    ],
    addresses: [
      {
        zipCode: postal,
        primary: true,
      },
    ],
  };
  const response = await fetch(
    PROXY +
      BASE_URL +
      REGISTRANTS +
      `/${registrantId}/person/contact-information`,
    {
      method: 'PUT',
      headers: HEADERS,
      body: JSON.stringify(dataBody),
    }
  );
  const responseJson = await response.json();

  return responseJson;
}

export async function updateRegistrantQuestionAnswers(
  registrantId,
  questionId,
  questionDOMValue,
  projectId,
  isArray
) {
  const HEADERS = headers(projectId);
  const dataBody = {
    answers: [],
  };
  if (isArray) {
    questionDOMValue.map((item) => dataBody.answers.push(item));
  } else {
    dataBody.answers.push({ answer: questionDOMValue });
  }

  const response = await fetch(
    PROXY + BASE_URL + REGISTRANTS + `/${registrantId}/questions/${questionId}`,
    {
      method: 'PUT',
      headers: HEADERS,
      body: JSON.stringify(dataBody),
    }
  );
  const responseJson = await response.json();

  return responseJson;
}
